module.exports = __webpack_public_path__ + "img/previewCamera.8e033f23.png";